import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import React from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import MediaService, { fallbackToLargestFile } from '../utils/DeviationMediaService';
import { BackgroundType, BackgroundImageDisplayMode } from './types';
import { TEMPLATES } from './templates';
import { gradientToClassName } from './utils';
import { styleFromWidthHeight } from '../DeviationViews/_helpers';
import { useDeviationMatureFilter } from '../utils/hooks/useDeviationMatureFilter';
import s from './Background.scss';
const Background = ({ className , contentClassName , backgroundClassName , children , onClick , variant ='custombox' , backgroundType , color , gradient , pattern , imageDisplayMode , imageTint , imageDeviation , width , height , style , noPadding , template: passedTemplate  })=>{
    const isCustomboxTemplatesPapiFlagEnabled = useFlag('custombox_templates_papi');
    const { showBlocked  } = useDeviationMatureFilter(imageDeviation);
    const backgroundClassNames = [];
    const sizeStyles = styleFromWidthHeight({
        width,
        height
    });
    const styles = {};
    switch(backgroundType){
        case BackgroundType.SOLID:
            // if the user has chosen a background color, use that.
            // If not, default to theme-based colors instead
            if (color) {
                styles.backgroundImage = `linear-gradient(${color}, ${color})`;
            } else {
                // we'll use a global css class that can be picked up by
                // shared's DaEditorWrapper custombox.scss
                backgroundClassNames.push(s['theme-based'], 'custombox_using_theme_defaults');
            }
            break;
        case BackgroundType.GRADIENT:
            backgroundClassNames.push(s['gradient'], gradientToClassName(gradient));
            break;
        case BackgroundType.PATTERN:
            backgroundClassNames.push(s['pattern']);
            styles.backgroundImage = `url(${pattern})`;
            break;
        case BackgroundType.IMAGE:
            backgroundClassNames.push(s['image']);
            const file = width && height ? MediaService.getSmallestThumbThatFullyCovers(imageDeviation, width, height, fallbackToLargestFile) : MediaService.getLargestFullview(imageDeviation);
            if (file) {
                styles.backgroundImage = `url("${file.src}")`;
            }
            if (imageTint) {
                styles.backgroundImage = `linear-gradient(${imageTint}, ${imageTint}), ${styles.backgroundImage}`;
            }
            if (showBlocked) {
                backgroundClassNames.push(s['mature-blur']);
            }
            switch(imageDisplayMode){
                case BackgroundImageDisplayMode.CONTAIN:
                    backgroundClassNames.push(s['display-mode-contain']);
                    break;
                case BackgroundImageDisplayMode.TILE:
                    backgroundClassNames.push(s['display-mode-repeat']);
                    break;
                case BackgroundImageDisplayMode.COVER:
                default:
                    backgroundClassNames.push(s['display-mode-cover']);
            }
            break;
        default:
            const template = isCustomboxTemplatesPapiFlagEnabled ? passedTemplate : TEMPLATES.find((t)=>t.moduleData.backgroundType === backgroundType);
            if (!template) {
                break;
            }
            backgroundClassNames.push(s['image']);
            if (template.backgroundImage) {
                styles.backgroundImage = `url("${template.backgroundImage}")`;
            }
            if (imageTint) {
                styles.backgroundImage = `linear-gradient(${imageTint}, ${imageTint}), ${styles.backgroundImage}`;
            }
            switch(imageDisplayMode){
                case BackgroundImageDisplayMode.CONTAIN:
                    backgroundClassNames.push(s['display-mode-contain']);
                    break;
                case BackgroundImageDisplayMode.TILE:
                    backgroundClassNames.push(s['display-mode-repeat']);
                    break;
                case BackgroundImageDisplayMode.COVER:
                default:
                    backgroundClassNames.push(s['display-mode-cover']);
            }
            break;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[`variant-${variant}`], noPadding && s['no-padding'], ...backgroundClassNames, className),
        onClick: onClick,
        style: _object_spread({}, sizeStyles, style)
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['background'], backgroundClassName),
        style: styles
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['content'], contentClassName)
    }, children));
};
Background.displayName = 'Background';
export default Background;
